import { render } from "./RightContent.vue?vue&type=template&id=ef509a64&scoped=true"
import script from "./RightContent.vue?vue&type=script&lang=js"
export * from "./RightContent.vue?vue&type=script&lang=js"

import "./RightContent.vue?vue&type=style&index=0&id=ef509a64&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef509a64"]])

export default __exports__